export const GET_CUSTOMERS_LOADING = 'GET_CUSTOMERS_LOADING';
export const GET_CUSTOMERS_SUCCESS = 'GET_CUSTOMERS_SUCCESS';
export const GET_CUSTOMERS_ERROR = 'GET_CUSTOMERS_ERROR';

export const START_FETCHING_CUSTOMERS = 'START_FETCHING_CUSTOMERS';
